module.exports = __webpack_public_path__ + "img/2019091804.1b3d51b5.jpg";